import React from 'react';
import Helmet from 'react-helmet';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

import ExitToAppIcon from '@material-ui/icons/ExitToApp';
import ReplayIcon from '@material-ui/icons/Replay';

import { colors } from '../../containers/S80/WindowConfig';
import { openDebugLogger, playerVersion } from '../../helpers/utils';

const Container = styled.div`
  background: ${colors.primary};
  display: flex;
  height: 100%;
  width: 100%;
  align-items: center;
  justify-content: center;
  & > svg {
    cursor: pointer;
    font-size: 100px;
    color: white;
  }
  & > svg.disabled {
    color: gray;
    cursor: not-allowed;
  }
  & > span {
    color: white;
  }
`;

const AppVersionSection = styled.div`
  position: fixed;
  z-index: 800;
  display: flex;
  align-items: center;
  bottom: 0px;
  color: #ffffff7d;
`;

export const LessonControllerTitle = () => {
  const { t } = useTranslation();
  return (
    <Helmet>
      <title>{`${t('appName')} - Lesson Controller ${playerVersion}`}</title>
    </Helmet>
  );
};

const AppVersion = () => {
  // if in electron environment then send open-debug-logger message to main process
  // to open the debug logger window otherwise open debug-logger in new tab
  const onDoubleClick = () => {
    openDebugLogger();
  };
  return (
    <AppVersionSection>
      <span onDoubleClick={onDoubleClick}>version: {`${playerVersion}`}</span>
    </AppVersionSection>
  );
};

export const LessonDidNotStartView = () => (
  <Container>
    <LessonControllerTitle />
    <span>Start the lesson in the main monitor first.</span>
    <AppVersion />
  </Container>
);

export const LessonStoppedView = ({ replayLesson, exitPlayer }) => (
  <Container>
    <ReplayIcon data-testid="replayIcon" onClick={replayLesson} />
    <ExitToAppIcon data-testid="exitIcon" onClick={exitPlayer} />
    <LessonControllerTitle />
    <AppVersion />
  </Container>
);
